import { call, fork, put, take } from 'redux-saga/effects';
import {Action} from 'redux-actions';
import {Api} from '../api';
import {Booking} from '../api/types';
import {
    FetchBookingDetailsPayload,
    FetchMultipleBookingDetailsPayload,
    fetchBookingDetails, fetchMultipleBookingDetails,
} from '../action/bookingsCommands';
import {bookingDetailsFetched} from '../action/bookingsEvents';
import {enqueueErrorSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import Logger from '../common/logger';

export const onFetchBooking = function*(bookingId: string) {
    try {
        const booking: Booking[] | Booking = yield call(Api.getBookingDetails, bookingId);

        yield put(bookingDetailsFetched({ booking: booking }));
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({ message: getI18n().t('snackbar.error.fetch_booking', { bookingId }) }));
    }
};

export function* fetchBookingFlow() {
    while (true) {
        const action: Action<FetchBookingDetailsPayload> = yield take(fetchBookingDetails.toString());

        yield fork(onFetchBooking, action.payload.bookingId);
    }
}

export const onFetchMultipleBooking = function*(bookingIds: string) {
    try {
        if (bookingIds !== ''){
            const booking: Booking[] = yield call(Api.getMultipleBookingDetails, bookingIds);
            Logger('***booking***').log(booking);
            yield put(bookingDetailsFetched({ booking }));
        }
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({ message: getI18n().t('snackbar.error.fetch_booking', { bookingIds }) }));
    }
};

export function* fetchMultipleBookingFlow() {
    while (true) {
        const action: Action<FetchMultipleBookingDetailsPayload> = yield take(fetchMultipleBookingDetails.toString());

        yield fork(onFetchMultipleBooking, action.payload.bookingIds);
    }
}
